export { Badge, renderBadge, useBadge } from './components/Badge';
export type { BadgeSlots, BadgeProps, BadgeState } from './components/Badge';
